import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { bizsolApiClient } from '@src/api/company/auth/bizsol/bizsolApiClient';
import { companyLogoutApiClient } from '@src/api/company/auth/companyLogoutApiClient.ts';
import SpinnerOverlay from '@src/components/SpinnerOverlay';
import { fetchCompanyUserProfile } from '@src/context/auth/ProfileFetcher';
import { useCompanyAuth } from '@src/context/auth/useCompanyAuth';
import { useToast } from '@src/features/toast/context/toastContext';
import { COMPANY_URL } from '@src/routes/company';
import { firstError } from '@src/utils/errorMessageUtils';
import logger from '@src/utils/logger';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function BizsolCallback() {
  const navigate = useNavigate();
  const toast = useToast();
  const { setProfile } = useCompanyAuth();

  useEffect(() => {
    const handleBizsolAuth = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const code = searchParams.get('code') || '';

      const res = await bizsolApiClient.userInfo(code);
      return handleApiResponse(
        res,
        async (data) => {
          if (data.authenticated && data.redirect_url) {
            setProfile(undefined);
            await fetchCompanyUserProfile(setProfile);
            window.location.href = data.redirect_url;
            return;
          }

          // 既存認証をクリア
          await companyLogoutApiClient.logout();
          
          // オートログインと同様にプロフィールをクリア後、再取得
          setProfile(undefined);
          await fetchCompanyUserProfile(setProfile);
          
          sessionStorage.setItem('bizsolUserInfo', JSON.stringify(data.user_info));
          navigate(COMPANY_URL.BIZSOL_INTRODUCTION);
        },
        (error) => {
          logger.error('BizsolCallback error:', firstError(error.message));
          toast('認証に失敗しました。');
          navigate(COMPANY_URL.LOGIN);
        },
      );
    };

    handleBizsolAuth();
  }, [navigate, toast, setProfile]);

  return <SpinnerOverlay loading={true} />;
}

export default BizsolCallback;
